import { render, staticRenderFns } from "./InviteesList.vue?vue&type=template&id=22cc996f&scoped=true"
import script from "./InviteesList.vue?vue&type=script&lang=js"
export * from "./InviteesList.vue?vue&type=script&lang=js"
import style0 from "./InviteesList.vue?vue&type=style&index=0&id=22cc996f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc996f",
  null
  
)

export default component.exports